var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#7B346E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55287 7.69388L5.73975 8.88075H3.375L4.55287 7.69388ZM5.73975 9.12825L4.55287 10.3061L3.375 9.12825H5.73975ZM7.344 7.52344L6.15712 8.70131V6.33712L7.344 7.52344ZM5.90962 8.70131L4.73231 7.52344L5.91019 6.33656L5.90962 8.70131ZM7.515 7.344L6.33712 6.16612H8.70131L7.515 7.344ZM7.515 4.73231L8.70131 5.91863H6.33712L7.515 4.73231ZM10.3061 4.56131L9.11925 5.73919V3.375L10.3061 4.56131ZM8.87175 5.73919L7.69388 4.56187L8.87175 3.375V5.73919ZM7.344 10.485L6.15712 11.6629V9.29869L7.344 10.485ZM4.73231 10.485L5.91019 9.29869V11.6629L4.73231 10.485ZM10.4766 7.344L9.29869 6.16612H11.6629L10.4766 7.344ZM9.29869 5.91863L10.4766 4.73175L11.6634 5.91863H9.29869ZM8.70188 12.0898L7.515 13.2677L6.33769 12.0898H8.70188ZM7.515 10.6554L8.70188 11.8423H6.33769L7.515 10.6554ZM13.2682 7.52344L12.0819 8.70131V6.33712L13.2682 7.52344ZM10.6566 7.52344L11.8344 6.33656V8.70131L10.6566 7.52344ZM7.69444 13.4466L8.87231 12.2608V14.625L7.69444 13.4466ZM9.11981 12.2608L10.3067 13.4471L9.11925 14.625L9.11981 12.2608ZM10.4771 13.2677L9.29925 12.0898H11.6634L10.4771 13.2677ZM10.4771 10.656L11.664 11.8429H9.29813L10.4771 10.656ZM12.0819 9.29869L13.2688 10.4856L12.0819 11.6629V9.29869ZM10.6566 10.4856L11.8344 9.29869V11.6629L10.6566 10.4856ZM13.4392 10.3056L12.2614 9.12825H14.625L13.4392 10.3056ZM13.4392 7.69388L14.625 8.88075H12.2608L13.4392 7.69388Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTau);
export default __webpack_public_path__ + "static/media/tau.2cbb125f7b5110ca1b7cfb3fb9908d60.svg";
export { ForwardRef as ReactComponent };